import React, { useContext } from 'react';
import { IconNavigationClose } from '@s-group/design-system-icons';
import { Button } from '../Button/Button.js';
import '../Locale/LocaleContext.js';
import { useTranslations } from '../Locale/hooks.js';
import { ModalContext } from './ModalContext.js';
import { MODAL_ACTION_CLOSE } from './constants.js';
import * as translations from './translations.js';

const buttonSizeOptions = {
    // modal sizing: close button sizing
    small: 'xsmall',
    medium: 'small',
    large: 'medium',
};
const ModalHeader = ({ children, className, closeButton, icon, id, sizing, }) => {
    var _a;
    const { dispatch } = (_a = useContext(ModalContext)) !== null && _a !== void 0 ? _a : {};
    const t = useTranslations(translations);
    const closeButtonSizing = (sizing) => sizing && buttonSizeOptions[sizing];
    const HeaderIcon = ({ icon }) => {
        if (!icon)
            return null;
        const [IconComponent, iconProps] = Array.isArray(icon)
            ? icon
            : 'props' in icon
                ? [icon.type, icon.props]
                : [icon];
        return React.createElement(IconComponent, { className: "modal-icon", ...iconProps });
    };
    const HeaderLabel = ({ children, id }) => {
        if (!children) {
            // This is needed just to exclude `undefined` from the return type.
            // In practice, the header is not rendered, if it is empty.
            return null;
        }
        if (typeof children === 'string') {
            return (React.createElement("h2", { className: "modal-label", id: id }, children));
        }
        return (React.createElement("div", { className: "modal-label", id: id }, children));
    };
    const handleCloseClick = () => {
        if (dispatch) {
            dispatch(MODAL_ACTION_CLOSE);
        }
    };
    return (React.createElement("div", { className: className },
        React.createElement(HeaderIcon, { icon: icon }),
        React.createElement(HeaderLabel, { id: id }, children),
        closeButton && (React.createElement(Button, { "aria-label": t('modal_header_button_close'), className: "modal-close", color: "neutral", icon: React.createElement(IconNavigationClose, null), onClick: handleCloseClick, sizing: closeButtonSizing(sizing), variant: "plain" }))));
};

export { ModalHeader, buttonSizeOptions };
//# sourceMappingURL=ModalHeader.js.map
